<template>
  <aside class="popup popup-padding">
    <header class="popup-top">
      <h2 class="title">
        ДОБАВИТЬ НАЗВАНИЕ ШАБЛОНУ
      </h2>
      <div class="popup-top_btns">
        <close-btn class="static"></close-btn>
      </div>

    </header>
    <form class="add-permission-form"
          @submit.prevent="sendEventTemplate">
      <label class="input-cont input-cont_small">
        <p class="label">ДОБАВИТЬ НАЗВАНИЕ ШАБЛОНУ</p>
        <input type="text"
               v-model="nameForTemplate"

               placeholder="Название шаблона">
<!--        <errors v-show="$v.pole.$error"></errors>-->
      </label>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="loading || disabled"
                :class="{'loading': loading}"
                class="btn btn-blue">{{$t('btns.add')}}</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import closeBtn from '../closeBtn'
  import {mapState, mapActions} from 'vuex'
  import {popups} from "../../../mixins/popups";
  import {toFormData} from "../../../mixins/utils/toFormData";

  export default {
    name: 'addEventName',
    components: {
      closeBtn
    },
    mixins: [popups, toFormData],
    data() {
      return {
        nameForTemplate: '',
        loading: false,
      }
    },
    computed: {
      ...mapState({
        tempData: state => state.journal.tempData,
      }),
      disabled() {
        return this.nameForTemplate.length < 1
      },
      thingsFirst() {
        return this.allThingsFromGetOwned.filter(item => !item.parent_device_id).map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
      },
    },
    methods: {
      ...mapActions({
        addDeviceInProject: 'projects/addDeviceInProject',
        getProject: 'projects/getProjects',
        getOwned: 'things/getDevices',
        saveEventTemplate: 'journal/saveEventTemplate'
      }),
      clearTempData() {
        this.tempData = {}
      },
      async sendEventTemplate() {
        // this.loading = true;
        this.tempData.name = this.nameForTemplate

        let formData = this.toFormData(this.tempData)
        await this.saveEventTemplate(formData)


        // this.loading = false;
        this.closeAll();

        this.tempData = {}
      }
    },
  }
</script>

<style lang="scss" scoped>
  .permission-toggler {
    margin: 15px 0;
  }
</style>
